module.exports = __webpack_public_path__ + "img/bLogo.333d1475.png";